// Core packages
import { Injectable } from '@angular/core';

// Third party packages
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Custom packages
import { ListApiResponseV2 } from 'src/app/shared/interfaces/_base/api-response.interface';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';

@Injectable({
  providedIn: 'root'
})
export class CaretakersService {

  /**
   * Class constructor
   */
  constructor(
    private apiService: ApiService,
    private helperService: HelperService
  ) { }
  
  /**
   * Get caretakers list for given query params
   *
   * @since 1.0.0
   *
   * @param [start] Query left offset
   * @param [limit] Results number
   * @param [sort] Sorting field name
   * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
   * @param [search] Filtering object with fildering data string
   */
  getList(start?: number, limit?: number, sort?: string, sortVersus?: string, search?: any): Observable<ListApiResponseV2> {
    const params: any = { start, limit, sort, sortVersus };
    if (search) {
      Object.keys(search).forEach(key => {
        const newParamKey = `search[${key}]`;
        const newParamValue = search[key];
        params[newParamKey] = newParamValue;
      });
    }
    return this.apiService.apiCall('GET', `condo-structures/caretakers-list`, params);
  }

  /**
   * Get an exportation file of caretakers
   *
   * @since 1.0.0
   */
  getExport(start?: number, limit?: number, sort?: string, sortVersus?: string, search?: any): Observable<any> {
    const params: any = { start, limit, sort, sortVersus };
    if (search) {
      Object.keys(search).forEach(key => {
        const newParamKey = `search[${key}]`;
        const newParamValue = search[key];
        params[newParamKey] = newParamValue;
      });
    }
    return this.apiService.apiCall('GET', 'condo-structures/caretakers-list-export', params, { responseType: 'blob' })
      .pipe(
        catchError(err => {
          return this.helperService.parseErrorBlob(err);
        })
      );
  }

  /**
   * Get all caretakers of all condoStructure
   *
   * @since 1.0.0
   *
   * @param 
   */
  getCaretakers(): Observable<any> {
    return this.apiService
      .apiCall("GET", `condo-structures/caretakers`)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }
}
